var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gritty flex flex-col items-center"},[_c('img',{staticClass:"w-full lg:w-screen-3/4",attrs:{"src":_vm.entry.entries[0].url,"alt":_vm.entry.description}})])}
var staticRenderFns = []

export { render, staticRenderFns }